(() => {
  'use strict';
  const calm = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Early-access flag from Omnisend's redirect (?ea=1). Convenience only, not consent or access control.
  try {
    if (new URLSearchParams(location.search).get('ea') === '1') {
      localStorage.setItem('ascend_early_access', '1');
      document.cookie = 'ascend_early_access=1; path=/; max-age=31536000; SameSite=Lax';
    }
  } catch (e) {}

  function init(root) {
    if (!root || root.dataset.apReady) return;
    root.dataset.apReady = '1';
    const $ = (s, el = root) => el.querySelector(s);
    const $$ = (s, el = root) => [...el.querySelectorAll(s)];
    const ready = root.dataset.ready === 'true';
    const gate = root.dataset.gate;
    const base = root.dataset.root || '/';

    const btn = $('[data-ap-btn]');
    const btnLabel = $('[data-ap-btn-label]');
    const msg = $('[data-ap-msg]');
    const priceEl = $('[data-ap-price]');
    const cwName = $('[data-ap-cw-name]');
    const dock = $('[data-ap-dock]');
    const dockBtn = $('[data-ap-dock-btn]');
    const dockSub = $('[data-ap-dock-sub]');
    const baseMsg = msg ? msg.textContent.trim() : '';
    const colors = $$('[data-ap-cw]');
    const state = { cw: root.dataset.initial, size: null, variant: null, added: false };

    const sizesFor = (h) => $(`[data-ap-sizes="${CSS.escape(h)}"]`);
    const labelOf = (h) => (colors.find((c) => c.dataset.apCw === h) || {}).dataset?.label || '';
    const setCompare = (c) => { const el = root.querySelector('[data-ap-compare]'); if (!el) return; el.textContent = c || ''; el.hidden = !c; };
    const setPrice = (p) => {
      if (priceEl) priceEl.textContent = p;
      const s = root.querySelector('[data-ap-btn-price]'); if (s) s.textContent = p; const dp = root.querySelector('[data-ap-dock-price]'); if (dp) dp.textContent = p;
    };
    const say = (t, alert) => { if (!msg) return; msg.textContent = t; msg.classList.toggle('is-alert', !!alert); };
    const resetBtn = () => {
      if (state.added || !btnLabel) return;
      if (!btnLabel.querySelector('[data-ap-btn-price]')) btnLabel.innerHTML = 'Preorder — <span data-ap-btn-price></span><span class="ap-btn__arrow" aria-hidden="true">→</span>';
      setPrice(priceEl ? priceEl.textContent : '');
    };
    const express = $('[data-ap-express]');
    const syncExpress = () => {
      if (!express) return;
      $$('[data-ap-pform]', express).forEach((f) => {
        const on = f.dataset.apPform === state.cw;
        f.hidden = !on;
        if (on && state.variant) { const i = $('[data-ap-pid]', f); if (i) i.value = state.variant; }
      });
      express.dataset.armed = state.variant ? 'true' : 'false';
    };
    const sync = () => {
      syncExpress();
      if (dockSub) dockSub.textContent = `${labelOf(state.cw)}${state.size ? ' · ' + state.size : ''} · ${priceEl ? priceEl.textContent : ''}`;
      resetBtn();
      if (!state.added) say(baseMsg);
    };

    function setColor(h, silent) {
      const group = sizesFor(h);
      if (!group) return;
      const keep = state.size;
      state.cw = h; state.size = null; state.variant = null; state.added = false;
      colors.forEach((c) => c.setAttribute('aria-checked', c.dataset.apCw === h ? 'true' : 'false'));
      $$('[data-ap-gal]').forEach((g) => { g.hidden = g.dataset.apGal !== h; });
      $$('[data-ap-sizes]').forEach((g) => { g.hidden = g.dataset.apSizes !== h; });
      if (cwName) cwName.textContent = labelOf(h);
      $$('.ap-size', group).forEach((b) => b.setAttribute('aria-checked', 'false'));
      setPrice(group.dataset.price); setCompare(group.dataset.compare);
      if (keep) {
        const same = $$('.ap-size', group).find((b) => b.textContent.trim() === keep && b.getAttribute('aria-disabled') !== 'true');
        if (same) pick(same);
      }
      $$('[data-ap-gal][hidden] video').forEach((v) => v.pause());
      watchVideos();
      sync();
      if (!silent) {
        try { const u = new URL(location.href); u.searchParams.set('color', h.replace(/^preview-/, '')); history.replaceState(null, '', u); } catch (e) {}
      }
    }

    function pick(b) {
      if (b.getAttribute('aria-disabled') === 'true') return;
      const group = b.closest('[data-ap-sizes]');
      $$('.ap-size', group).forEach((x) => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
      state.size = b.textContent.trim();
      state.variant = b.dataset.variant || null;
      state.added = false;
      if (b.dataset.price) setPrice(b.dataset.price);
      if (b.dataset.compare !== undefined) setCompare(b.dataset.compare);
      sync();
    }

    colors.forEach((c) => c.addEventListener('click', () => setColor(c.dataset.apCw)));
    $$('.ap-size').forEach((b) => b.addEventListener('click', () => pick(b)));
    $$('.ap-colors, .ap-sizes').forEach((grp) => grp.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
      const items = $$('[role="radio"]', grp).filter((x) => x.getAttribute('aria-disabled') !== 'true');
      const i = items.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      const n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
      n.focus(); n.click();
    }));

    function nudge() {
      const g = sizesFor(state.cw); if (!g) return;
      g.classList.remove('is-nudge'); void g.offsetWidth; g.classList.add('is-nudge');
    }

    async function buy() {
      if (state.added) { location.href = base + 'checkout'; return; }
      if (!state.size) { say('Choose a size first.', true); nudge(); return; }
      if (!ready) {
        const why = { preview: 'Preview only. Checkout opens at launch.', off: 'Checkout opens at launch.', ship: 'Checkout opens once the shipping date is set.' }[gate] || 'Checkout is not open yet.';
        say(`${labelOf(state.cw)}, size ${state.size}. ${why}`, true);
        return;
      }
      btn.dataset.state = 'busy';
      try {
        const r = await fetch(base + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(state.variant), quantity: 1 }] }),
        });
        const d = await r.json();
        if (!r.ok) throw new Error(d.description || 'That size could not be added.');
        const cart = await fetch(base + 'cart.js').then((x) => x.json());
        $$('[data-ap-count]').forEach((c) => { c.textContent = cart.item_count; });
        state.added = true;
        btn.dataset.state = '';
        btnLabel.innerHTML = 'Added — go to checkout<span class="ap-btn__arrow" aria-hidden="true">→</span>';
        say(`${labelOf(state.cw)}, size ${state.size} is in your cart.`);
      } catch (err) {
        btn.dataset.state = '';
        say(err.message || 'Something went wrong. Try again.', true);
      }
    }
    if (btn) btn.addEventListener('click', buy);
    const guard = $('[data-ap-express-guard]');
    if (guard) guard.addEventListener('click', () => { say('Choose a size first.', true); nudge(); });
    if (dockBtn) dockBtn.addEventListener('click', () => {
      if (!state.size) {
        const g = sizesFor(state.cw);
        if (g) g.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' });
        setTimeout(nudge, 300);
        say('Choose a size first.', true);
        return;
      }
      buy();
    });
    if (dock && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        dock.classList.toggle('is-on', on);
        dock.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (dockBtn) dockBtn.tabIndex = on ? 0 : -1;
      }).observe(btn);
    }

    /* Size guide */
    const guide = $('[data-ap-guide]');
    $$('[data-ap-guide-open]').forEach((b) => b.addEventListener('click', () => guide && guide.showModal && guide.showModal()));
    if (guide) {
      $('[data-ap-guide-close]', guide).addEventListener('click', () => guide.close());
      guide.addEventListener('click', (e) => { if (e.target === guide) guide.close(); });
    }

    /* Mobile photo counter */
    $$('[data-ap-gal]').forEach((g) => {
      const t = $('[data-ap-track]', g); const idx = $('[data-ap-idx]', g);
      if (!t || !idx) return;
      t.addEventListener('scroll', () => { idx.textContent = Math.round(t.scrollLeft / t.clientWidth) + 1; }, { passive: true });
    });

    /* Video: load and play only while on screen; manual play/pause */
    const holder = (v) => v.closest('.ap-gal__item, .ap-close, .ap-look__v, .ap-manifesto');
    const load = (v) => {
      if (v.dataset.loaded) return;
      const srcs = [...v.querySelectorAll('source[data-src]')];
      const want = innerWidth < 900 ? 720 : 1080;
      const best = srcs.sort((a, b) => Math.abs(+a.dataset.h - want) - Math.abs(+b.dataset.h - want))[0];
      srcs.forEach((s) => { if (s !== best) s.remove(); });
      if (best) { best.src = best.dataset.src; v.load(); }
      v.dataset.loaded = '1';
    };
    const play = (v) => { load(v); const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    $$('[data-ap-video]').forEach((v) => {
      v.addEventListener('playing', () => { const h = holder(v); if (h) h.dataset.playing = 'true'; });
      v.addEventListener('pause', () => { const h = holder(v); if (h) h.dataset.playing = 'false'; });
      const b = holder(v) && holder(v).querySelector('[data-ap-vplay]');
      if (b) b.addEventListener('click', () => {
        if (v.paused) { delete v.dataset.userPaused; play(v); b.setAttribute('aria-label', 'Pause video'); }
        else { v.dataset.userPaused = '1'; v.pause(); b.setAttribute('aria-label', 'Play video'); }
      });
    });
    let io;
    function watchVideos() {
      if (!('IntersectionObserver' in window)) return;
      if (!io) io = new IntersectionObserver((es) => es.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting && en.intersectionRatio > 0.4) { if (!calm() && !v.dataset.userPaused && !v.closest('[hidden]')) play(v); }
        else if (!v.paused) v.pause();
      }), { threshold: [0, 0.4] });
      $$('[data-ap-video]').forEach((v) => { io.unobserve(v); if (!v.closest('[hidden]')) io.observe(v); });
    }

    /* Rise on scroll */
    root.classList.add('is-js');
    const rises = $$('[data-ap-rise]');
    if ('IntersectionObserver' in window && !calm()) {
      const rio = new IntersectionObserver((es) => es.forEach((en) => {
        if (!en.isIntersecting) return;
        const sibs = [...en.target.parentElement.children];
        en.target.style.transitionDelay = (Math.max(0, sibs.indexOf(en.target)) * 90) + 'ms';
        en.target.classList.add('is-in'); rio.unobserve(en.target);
      }), { rootMargin: '0px 0px -10% 0px' });
      rises.forEach((r) => rio.observe(r));
    } else rises.forEach((r) => r.classList.add('is-in'));

    /* Lookbook: drag to scroll with a mouse */
    $$('[data-ap-drag]').forEach((t) => {
      let down = false, x0 = 0, s0 = 0, moved = false;
      t.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = t.scrollLeft; t.classList.add('is-dragging'); });
      addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; t.scrollLeft = s0 - dx; });
      addEventListener('pointerup', () => { if (!down) return; down = false; t.classList.remove('is-dragging'); });
      t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); t.scrollBy({ left: t.clientWidth * 0.6, behavior: calm() ? 'auto' : 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); t.scrollBy({ left: -t.clientWidth * 0.6, behavior: calm() ? 'auto' : 'smooth' }); }
      });
    });

    /* Start on ?color= if given */
    let start = state.cw;
    try {
      const want = new URLSearchParams(location.search).get('color');
      const hit = want && colors.find((c) => c.dataset.apCw === want || c.dataset.apCw.endsWith(want));
      if (hit) start = hit.dataset.apCw;
    } catch (e) {}
    setColor(start, true);
  }

  const boot = () => document.querySelectorAll('[data-ap]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-ap]').forEach(init));
  document.addEventListener('shopify:block:select', (e) => {
    const c = e.target.closest('[data-ap-cw]'); if (c) c.click();
  });
})();
